<ng-container *ngIf="!disabled">
	<ng-container *ngTemplateOutlet="buttonReceipt"></ng-container>
</ng-container>

<zk-tooltip
	*ngIf="disabled"
	theme="default"
	tooltipMessage="{{ 'SCHEDULE.RECEIPT.PROFESSIONAL_INACTIVE' | translate }}"
>
	<ng-container *ngTemplateOutlet="buttonReceipt"></ng-container>
</zk-tooltip>

<ng-template #buttonReceipt>
	<freud-button
		[zkButtonLoading]="isLoading"
		[disabled]="disabled || shouldDisableReceiptButton"
		class="receipt-button"
		icon="freud-icon freud-icon-receipt"
		iconPos="left"
		[label]="'SCHEDULE.RECEIPT.BUTTON' | translate"
		(click)="generateReceipt()"
		id="generate-receipt-button"
		color="secondary"
	>
	</freud-button>
</ng-template>
